/**
 * Const element
 * Modalreleasenotes component
 * Display a modal of release notes
 */
/* Import section */
import { StaticQuery, graphql } from "gatsby"
import React, { Component } from "react"
import { IconContext } from "react-icons"
import { BsX } from "react-icons/bs"
import Cardreleasenotes from "../components/cardreleasenotes"
import Cookies from "universal-cookie"
import "../styles/components/modalreleasenotes.scss"

const cookies = new Cookies()

/* Declaration main class with StaticQuery */
class Modalreleasenotes extends Component {
  constructor(props) {
    super(props)
    this.state = {
      width: 0,
      showModal: false,
    }
  }

  componentDidMount() {
    (cookies.get('viewed_cookie_modal') !== undefined && this.setState({ showModal: cookies.get('viewed_cookie_modal')}))
  }

  closeModal(e) {
    cookies.set('viewed_cookie_modal', false, { path: '/'})
    this.setState({
      width: window.innerWidth,
      showModal: cookies.get('viewed_cookie_modal')
    })

    document.body.style.overflow = 'auto'
    var modal = [].slice.call((document.getElementsByClassName("modal-releasenotes")))
    modal[0].classList.add("hidden")
  }

  render () {
    const dataLastRelease = this.props.dataLastRelease.edges
    var classNameModal=(this.state.showModal === true) ? "":"hidden";

    return (
      <div className={`modal-releasenotes ${classNameModal}`}>
        <div className="header-modal">
          <h2>Product Updates</h2>
          <button className="button-close-modal" aria-label="Close the modal" onClick={() => this.closeModal()}>
            <span>
              <IconContext.Provider value={{ className: "svg-modal" }}>
                <i aria-hidden="true"><BsX /></i>
              </IconContext.Provider>
            </span>
          </button>
        </div>
        {dataLastRelease.map( (release, index) => (
          <Cardreleasenotes key={index} classRelease="login" titleRelease={release.node.title} slugRelease={release.node.slug} contentRelease={release.node.acfPostRelease} />
        ))}
      </div>
    )
  }
}

export default props => (
  <StaticQuery
    query={
      graphql`
        query {
          lastRelease: allWpRelease(sort: {fields: [date], order:DESC}, limit: 2) {
            edges {
              node {
                title
                slug
                content
                date (
                  formatString: "MMMM YY"
                )
                acfPostRelease {
                  repeaterLevel1 {
                    contentLevel1
                    titleLevel1
                    typeLevel1
                    repeaterLevel2 {
                      contentLevel2
                      titleLevel2
                    }
                  }
                }
              }
            }
          }
        }
      `
    }
    render={({ lastRelease }) => <Modalreleasenotes dataLastRelease={lastRelease} {...props} />}
  />
);
